
import $ from "jquery"
import URI from "urijs"

const INIT_COMPLETE_CLASS = "cell--app--current-area-size-unit--selection-menu--navbar-style__js-init-done"


export interface Selector {
  cell:  string | JQuery | Element
  links: string
}
export interface InputSelector {
  cell?:  string | JQuery | Element
  links?: string
}
const default_selector = {
  cell:  ".cell--app--current-area-size-unit--selection-menu--navbar-style",
  links: ".cell--app--current-area-size-unit--selection-menu--navbar-style__link",
}

class Component {
  protected selector: Selector

  protected $cell: JQuery
  protected $links: JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, default_selector, selector)

    this.$cell = $(this.selector.cell)
    this.$links = this.$cell.find(this.selector.links)

    this.bind_action()
  }

  protected bind_action(){
    if (this.$cell.hasClass(INIT_COMPLETE_CLASS)) { return this }

    this.$cell.addClass(INIT_COMPLETE_CLASS)

    this.$links.each((_idx, link) => {
      const $link = $(link)
      const area_size_unit = $link.data("area-size-unit")

      const new_url = URI(window.location)
      new_url.addSearch("current_area_size_unit", area_size_unit)

      $link.attr("href", new_url.toString())
    })
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new Component(selector)
  },
}

export {
  Factory,
}
